import { render, staticRenderFns } from "./DomainImage.vue?vue&type=template&id=388c132c&"
import script from "./DomainImage.vue?vue&type=script&lang=js&"
export * from "./DomainImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports